import * as THREE from "three";

const FLASH_DURATION = 0.06;

export class MuzzleFlash {
  private readonly light: THREE.PointLight;
  private readonly mesh: THREE.Mesh;
  private life = 0;

  constructor(parent: THREE.Object3D) {
    this.light = new THREE.PointLight(0xccffaa, 0, 30);
    this.light.position.set(0, 0, 0);
    const geo = new THREE.SphereGeometry(0.38, 6, 6);
    geo.scale(1.2, 0.7, 1.2);
    const mat = new THREE.MeshBasicMaterial({
      color: 0xfff2b8,
      transparent: true,
      opacity: 0,
      depthWrite: false,
    });
    this.mesh = new THREE.Mesh(geo, mat);
    this.mesh.visible = false;
    this.mesh.userData["isVFX"] = true;
    parent.add(this.light, this.mesh);
  }

  flash(): void {
    this.light.intensity = 6;
    this.mesh.visible = true;
    (this.mesh.material as THREE.MeshBasicMaterial).opacity = 0.95;
    this.mesh.scale.setScalar(1.15);
    this.life = FLASH_DURATION;
  }

  update(dt: number): void {
    if (this.life <= 0) return;
    this.life -= dt;
    if (this.life > 0) {
      const t = this.life / FLASH_DURATION;
      this.light.intensity = t * 6;
      (this.mesh.material as THREE.MeshBasicMaterial).opacity = t * 0.9;
      this.mesh.scale.setScalar(1.15 + (1 - t) * 0.8);
    } else {
      this.light.intensity = 0;
      this.mesh.visible = false;
      (this.mesh.material as THREE.MeshBasicMaterial).opacity = 0;
    }
  }
}
